import { GET_PROFILE, UPDATE_PROFILE, UPLOAD_AVATAR } from 'modules/dashboard/store/constants';

export const updateProfile = ({ firstName, lastName, phone }) => ({
  type: UPDATE_PROFILE,
  payload: {
    firstName,
    lastName,
    phone,
  },
});

export const getProfile = () => ({
  type: GET_PROFILE,
});

export const uploadAvatar = (avatar) => ({
  type: UPLOAD_AVATAR,
  payload: {
    avatar,
  },
});
